class LazyImageLoader{
  constructor(){this.images=[];this.loaded=new Set();this.observer=null;this.smoother=typeof ScrollSmoother!=='undefined'&&ScrollSmoother.get();this.inited=false;this.init()}
  init(){
    if(this.inited) return;
    this.collect();
    if(this.smoother && typeof ScrollTrigger!=='undefined') this.setupBatch();
    else this.setupObserver();
    this.inited=true
  }
  collect(){
    this.images=Array.from(document.querySelectorAll('img[data-src],img[loading="lazy"]')).filter(img=>!img.closest('.pb-lightbox,.product-lightbox,.lightbox-content'));
    this.images.forEach((img,i)=>{
      if(!img.dataset.lazyId) img.dataset.lazyId=`lazy-${Date.now()}-${i}`;
      if(img.dataset.src && !img.dataset.originalSrc) img.dataset.originalSrc=img.dataset.src;
      img.classList.add('lazy-image');
      img.style.opacity='0';
      img.style.transition='opacity .3s ease';
      img.style.willChange='opacity';
    });
  }
  setupBatch(){
    const targets=this.images;
    ScrollTrigger.batch(targets,{
      start:"top bottom+=200px",
      onEnter:batch=>{batch.forEach(img=>this.loadImage(img))},
      onEnterBack:batch=>{batch.forEach(img=>this.loadImage(img))}
    });
  }
  setupObserver(){
    if(!this.images.length) return;
    const opts={root:null,rootMargin:'300px 0px',threshold:0.01};
    this.observer=new IntersectionObserver((entries)=>{
      entries.forEach(e=>{
        if(e.isIntersecting){this.loadImage(e.target);this.observer.unobserve(e.target)}
      });
    },opts);
    this.images.forEach(img=>this.observer.observe(img));
  }
  loadImage(img){
    if(!img||this.loaded.has(img.dataset.lazyId)) return;
    const src=img.dataset.src||img.dataset.originalSrc||img.src;
    if(!src||src.startsWith('data:')) return;
    this.loaded.add(img.dataset.lazyId);
    img.classList.add('lazy-loading');
    const pre=new Image();
    pre.decoding='async';
    const apply=()=>{
      img.src=src;
      img.classList.add('lazy-loaded');
      img.classList.remove('lazy-loading');
      img.style.opacity='1';
      if(typeof ScrollSmoother!=='undefined'&&ScrollSmoother.get()) try{ScrollSmoother.get().refresh()}catch(e){}
      else if(typeof ScrollTrigger!=='undefined') try{ScrollTrigger.refresh()}catch(e){}
      img.dispatchEvent(new CustomEvent('lazyImageLoaded',{detail:{imageId:img.dataset.lazyId,src}}));
    };
    pre.onload=()=>{
      if(pre.decode) pre.decode().then(()=>{
        if(typeof requestIdleCallback!=='undefined') requestIdleCallback(apply,{timeout:500});
        else setTimeout(apply,50);
      }).catch(()=>{
        if(typeof requestIdleCallback!=='undefined') requestIdleCallback(apply,{timeout:500});
        else setTimeout(apply,50);
      });
    };
    pre.onerror=()=>{img.classList.add('lazy-error');img.classList.remove('lazy-loading')};
    pre.src=src;
  }
  loadAll(){this.images.forEach(img=>this.loadImage(img))}
  refresh(){this.destroy();this.init()}
  destroy(){
    if(this.observer){try{this.observer.disconnect()}catch(e){} this.observer=null}
    if(typeof ScrollTrigger!=='undefined'&&this.images.length){
      try{
        const all=ScrollTrigger.getAll();
        all.forEach(st=>{try{if(st.trigger&&this.images.indexOf(st.trigger)!==-1)st.kill()}catch(e){}});
      }catch(e){}
    }
    this.images=[];this.loaded.clear();this.inited=false
  }
}
(function injectCSS(){
  if(document.getElementById('lazy-loader-styles')) return;
  const s=document.createElement('style');
  s.id='lazy-loader-styles';
  s.textContent='.lazy-image{transition:opacity .3s ease;opacity:0;will-change:opacity}.lazy-loaded{opacity:1!important}.lazy-loading{position:relative}.lazy-error{opacity:.3;filter:grayscale(100%)}';
  document.head.appendChild(s);
})();
function initLazyLoading(){
  if(window.lazyLoader instanceof LazyImageLoader){window.lazyLoader.refresh();return}
  window.lazyLoader=new LazyImageLoader();
  if(typeof barba!=='undefined'&&barba.hooks) barba.hooks.afterEnter&&barba.hooks.afterEnter(()=>setTimeout(()=>window.lazyLoader.refresh(),120));
  if(typeof ScrollSmoother!=='undefined'){const check=()=>{if(ScrollSmoother.get()) window.lazyLoader.refresh(); else setTimeout(check,150)};check()}
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initLazyLoading); else initLazyLoading();
window.initLazyLoading=initLazyLoading;
window.LazyImageLoader=LazyImageLoader;